import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const Styled = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDragActive",
})(({ theme }) => ({
  border: "2px dotted",
  borderColor: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  padding: "0.625rem 0.3125rem",
  backgroundColor: "#696969",
  boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)",
  transition: "all 0.3s ease-out",
  "& .MuiTypography-root": {
    textTransform: "uppercase",
    fontSize: ".9rem",
    fontWeight: "500",
  },
  "&:hover": { cursor: "pointer" },
  ...theme.applyStyles("light", {
    borderColor: theme.palette.secondary.main,
    backgroundColor: "#d8d8d8",
  }),
  variants: [
    {
      props: ({ isDragActive }) => isDragActive,
      style: {
        padding: "6.25rem 0.3125rem",
        backgroundColor: "#4f6e4e",
        ...theme.applyStyles("light", { backgroundColor: "#d4f9d3" }),
      },
    },
  ],
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  "& .MuiTypography-root": {
    marginTop: "1rem",
    textOverflow: "ellipsis",
    fontSize: "0.9rem",
    fontWeight: "600",
  },
  "& .errorMsg": {
    color: theme.palette.error.main,
  },
}));
